import { Box } from "@mui/material";
import React from "react";
import { ActiveWork } from "../../../services/researchApi";
import {
  AgentActivity,
  ResearchEntity,
  WorkflowStage,
} from "../../../types/researchWorkflow";
import AgentTab from "./AgentTab";

interface AgentPanelProps {
  currentStage: WorkflowStage;
  activeWork: ActiveWork;
  activities: AgentActivity[];
  activitiesLoading: boolean;
  selectedEntity?: ResearchEntity;
  onClearSelection: () => void;
}

const AgentPanel: React.FC<AgentPanelProps> = ({
  currentStage,
  activeWork,
  activities,
  activitiesLoading,
  selectedEntity,
  onClearSelection,
}) => {
  return (
    <Box
      sx={{
        width: 420,
        borderLeft: 1,
        borderColor: "divider",
        backgroundColor: "background.paper",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <AgentTab
        currentStage={currentStage}
        activeWork={activeWork}
        activities={activities}
        activitiesLoading={activitiesLoading}
        selectedEntity={selectedEntity}
        onClearSelection={onClearSelection}
      />
    </Box>
  );
};

export default AgentPanel;
